<template>
  <div :style="!standalone ? 'margin:20px' : 'margin:5px'">
    <div v-if="standalone">
      <span style="font-size: 20px; font-weight: bold; margin-bottom: 10px;" class="d-flex align-items-center justify-content-center">
        <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img style="margin-top:-5px" width="40" src="favicon.ico"/></a>&nbsp;VSM&nbsp;
        <b-spinner v-if="reloading" style="width: 1.8rem; height: 1.8rem"></b-spinner><span v-else style="width: 1.8rem; height: 1.8rem">&nbsp;</span>
      </span>
    </div>

    <div v-if="!loading">
      <div class="row" style="margin: 5px 0px 5px 0px; font-weight: bold; font-size: 18px;">
        <div @click="filter_by_status(null)" :style="selected_vehicle_statuses.length === 0 ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col total" style="border: 1px solid grey;">{{items.length}} de {{summary.total_cnt}}</div>
        <div v-if="washed_enabled" @click="filter_by_status('ready')" :style="selected_vehicle_statuses.includes('ready') ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col ready">Listo-{{ready_cnt}}</div>
      </div>
      <div class="row" style="margin: 5px 0px 5px 0px; font-weight: bold; font-size: 18px;">
        <div @click="filter_by_status('cleaned')" :style="selected_vehicle_statuses.includes('cleaned') ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col cleaned">Limpio-{{clean_cnt}}</div>
        <div v-if="washed_enabled" @click="filter_by_status('washed')" :style="selected_vehicle_statuses.includes('washed') ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col washed">Lavado-{{washed_cnt}}</div>
        <div @click="filter_by_status('dirty')" :style="selected_vehicle_statuses.includes('dirty') ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col dirty">Sucio-{{dirty_cnt}}</div>
      </div>
      <div class="row" style="margin: 5px 0px 5px 0px; font-weight: bold; font-size: 18px;">
        <div @click="filter_by_status('out')" :style="selected_vehicle_statuses.includes('out') ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col out">En La Carretera-{{out_cnt}}</div>
        <div @click="filter_by_status('oos')" :style="selected_vehicle_statuses.includes('oos') ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col oos">En La Garage-{{oos_cnt}}</div>
      </div>
    </div>
    <div v-if="summary">
      <b-table :busy="loading" :sticky-header="windowHeight ? windowHeight*.90 + 'px':'80vh'" bordered :items="items" :fields="fields" :tbody-tr-class="get_row_color"
               :current-page="currentPage" :sort-compare="tableSortCompare" :style="'font-size:' + summary.font_size + 'px'" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
          </div>
        </template>

        <template slot="name" slot-scope="row">
          <a style="font-size: 22px" target="_blank" :href="'/#/vehicle-track/' + tenant_id + '/' + row.item.name">{{row.item.name}}</a>
        </template>

        <template slot="vehicle_status" slot-scope="row">
          <span v-if="row.item.future_booking">
            FUTURO
          </span>
          <span v-else>
            {{getOptionText(status_options, row.item.vehicle_status)}}
          </span>
        </template>

        <template slot="next_mvmt_time" slot-scope="row">
          {{row.item.next_mvmt_time | formatDateTimeCustom(summary.datetime_format)}}
          <template v-if="!driver_mode && row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_time | formatDateTimeCustom(summary.datetime_format)}}
          </template>
        </template>

      </b-table>
      <b-row v-if="!standalone && items.length > 10">
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div class="text-center text-danger my-2">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import {api_url, delete_vehicle_status, get_vehicle_info, get_vehicle_info_history, update_vehicle_status, update_vehicle_status_anonymous} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment';
import datetime from 'vuejs-datetimepicker';
import {justDate} from "../helpers/dates";
import axios from "axios";

export default {
  name: 'vehicle_status_es',
  components: {
     datetime
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      windowHeight: window.innerHeight,
      search_filter: '',
      tenant_id: null,
      show_add_vehicle_info_modal: false,
      add_vehicle_info_model: {'manual_record': true},
      updating: false,
      washed_enabled: true,
      standalone: false,
      mobile_view: false,
      driver_mode: false,
      cleaning_mode: false,
      maintenance_mode: false,
      view_more_info: false,
      update_status_modal: false,
      columnSelection: false,
      reloading: false,
      reload_mode: 0,
      return_mode: false,
      timer: null,
      items: [],
      items_full: [],
      summary: null,
      loading: true,
      selected_vehicle_statuses: [],
      selected_base: '',
      selected_vehicle_tag: '',
      base_options: [],
      vehicle_tag_options: [],
      scheduled_options: [],
      washbay_assignment_options: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 300,
      pages: [],
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      status_options: [
        { value: '', text: 'ALL' },
        { value: 'READY', text: 'Listo' },
        { value: 'CLEANED', text: 'Limpio' },
        { value: 'WASHED', text: 'Lavado' },
        { value: 'DIRTY', text: 'Sucio' },
        { value: 'OUT', text: 'En La Carretera' },
        { value: 'OOS', text: 'En La Garage' },
      ],
      reload_options: [
        { value: 0, text: 'OFF' },
        { value: 30000, text: '30s' },
        { value: 60000, text: '1m' },
        { value: 300000, text: '5m' },
      ],
      fields: [
        { key: 'name', label: 'Vehículo', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'vehicle_status', label:'Estado', sortable: true, visible: true, thStyle: { width: "130px" }},
        { key: 'next_mvmt_time', label:'Próxima Salida', sortable: true, visible: true, thStyle: { width: "160px" }},
      ],
    }
  },
  async created() {
    this.fields_all = this.fields
    await this.check_features()
  },
  mounted() {
    this.stopTimer()
  },
  beforeDestroy() {
    this.stopTimer()
  },
  methods: {
    startTimer() {
      this.stopTimer()
      if (this.reload_mode > 0) {
        this.timer = setInterval(() => this.reload_data(), this.reload_mode)
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async resetTimerAndReload() {
      this.stopTimer()
      await this.reload_data()
      this.startTimer()
    },
    getOptionText(options, value) {
      const option = options.find(opt => opt.value === value)
      return option ? option.text : value
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.mobile_view = true;
        return true
      } else {
        return false
      }
    },
    isTablet() {
      if(/iPad/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    tableSortCompare(aRow, bRow, key) {
      if (key == 'next_mvmt_delta') {
        return aRow['next_mvmt_ms'] - bRow['next_mvmt_ms']
      }
      if (key == 'current_mvmt_return_delta') {
        return aRow['current_mvmt_return_ms'] - bRow['current_mvmt_return_ms']
      }
      return false;
    },
    async check_features() {

      if (this.$route.path.indexOf('/vsm-es/') == -1) {
        this.standalone = false
        this.tenant_id = this.user.tenant
      }
      else if (this.$route.path.indexOf('/vsm-es/reload/') != -1) {
        this.standalone = true
        this.tenant_id = this.$route.path.split('/vsm-es/reload/')[1]
        this.reload_mode = 60000
      }

      this.fields = this.fields_all

      this.load_data()
    },
    async update_next_scheduled_config(row, item) {
      if (this.reloading)
        return;

      this.updating = true
      try {

        let json = {
          'name': item.name,
          'next_scheduled_config':  item.next_scheduled_config,
        }

        const {value: { data = [] } } = await update_vehicle_status(this.tenant_id, json)

        if (data.next_mvmt_ms && (!item.next_mvmt_ms || data.next_mvmt_ms < item.next_mvmt_ms)) {
          item.next_mvmt_delta = data.next_mvmt_delta
          item.next_mvmt_ms = data.next_mvmt_ms
        }
        item.next_daily_scheduled_time = data.next_daily_scheduled_time

        if (row.detailsShowing)
          row.toggleDetails();

      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.updating = false
    },
    async update_next_scheduled_time(row, item, next_scheduled_time) {
      if (this.reloading)
        return;

      this.updating = true
      try {

        let json = {
          'name': item.name,
          'next_scheduled_time':  next_scheduled_time,
        }

        const {value: { data = [] } } = await update_vehicle_status(this.tenant_id, json)

        if (data.next_mvmt_ms && (!item.next_mvmt_ms || data.next_mvmt_ms < item.next_mvmt_ms)) {
          item.next_mvmt_delta = data.next_mvmt_delta
          item.next_mvmt_ms = data.next_mvmt_ms
        }

        if (row.detailsShowing)
          row.toggleDetails();

      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.updating = false
    },
    async update_vehicle_status(row, item) {
      console.log("updating vehicle status: " + item.name)

      this.updating = true
      try {

        let json = {
          'name': item.name,
          'vehicle_status':  item.vehicle_status,
          'washbay_assignment':  item.washbay_assignment,
        }

        const {value: { data = [] } } = await update_vehicle_status(this.tenant_id, json)

        if (data.vehicle_status)
          item.vehicle_status = data.vehicle_status
        if (data.dump_date)
          item.dump_date = data.dump_date
        if (data.detailed_date)
          item.detailed_date = data.detailed_date

        if (data.next_mvmt_delta) {
          item.next_mvmt_delta = data.next_mvmt_delta
          item.next_mvmt_ms = data.next_mvmt_ms
        }

        if (row.detailsShowing)
          row.toggleDetails();


      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.updating = false
    },
    async add_new_status_record(row, item) {
      this.updating = true
      try {
        if (this.standalone) {
          try {
            if (this.summary.visible_update_fields.indexOf('username') == -1)
              item.username = 'anonymous'

            const {value: {data = []}} = await update_vehicle_status_anonymous(this.tenant_id, item)
            if (data.vehicle_status)
              item.vehicle_status = data.vehicle_status
            if (data.dump_date)
              item.dump_date = data.dump_date
            if (data.detailed_date)
              item.detailed_date = data.detailed_date

          } catch(e){
            this.showAlert("unable to save new status record, invalid username", 'danger', 5000)
            return;
          }
        } else {
          const {value: {data = []}} = await update_vehicle_status(this.tenant_id, item)
          if (data.vehicle_status)
            item.vehicle_status = data.vehicle_status
          if (data.dump_date)
            item.detailed_date = data.dump_date
          if (data.detailed_date)
            item.detailed_date = data.detailed_date
        }

        if (this.summary.visible_update_fields.indexOf('username') != -1)
          row.toggleDetails();

      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.updating = false
    },
    async load_data() {
      this.loading = true
      try {
        var results = await get_vehicle_info(this.tenant_id, this.selected_base, this.selected_vehicle_tag, this.return_mode)
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results

        if (this.standalone && data.summary.window_height)
          this.windowHeight = data.summary.window_height

        this.filter_items()

        this.stopTimer()
        if (this.reload_mode > 0) {
          this.startTimer()
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
        this.stopTimer()
        this.loading = false
      }

      this.loading = false
    },
    async reload_data() {
      try {
        if (this.updating)
          return;

        if (this.$pageVisibility && this.$pageVisibility.hidden)
          return;

        if (this.reloading)
          return;

        this.reloading = true

        var results = await get_vehicle_info(this.tenant_id, this.selected_base, this.selected_vehicle_tag, this.return_mode)
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.filter_items()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.reloading = false
    },
    filter_by_status(status) {
      if (status == null) {
        this.selected_vehicle_statuses = []
      } else if (this.selected_vehicle_statuses.includes(status)) {
        this.selected_vehicle_statuses = this.selected_vehicle_statuses.filter(s => s !== status)
      } else {
        this.selected_vehicle_statuses = [...this.selected_vehicle_statuses, status]
      }
      this.filter_items()
    },
    filter_items(status) {
      this.items = this.items_full
      if (this.selected_vehicle_statuses.length > 0) {
        const upper = this.selected_vehicle_statuses.map(s => s.toUpperCase())
        this.items = this.items.filter(item => upper.includes(item.vehicle_status))
      }
      if (this.selected_vehicle_tag) {
        this.items = this.items.filter(item => this.contains(item.vehicle_tags,this.selected_vehicle_tag))
      }
      if (status) {
        this.items = this.items.filter(item => item.vehicle_status == status)
      }
      if (this.search_filter != '') {
        this.items = this.items.filter(item => (this.contains(item.start_bases, this.search_filter) || this.contains(item.next_mvmt_driver, this.search_filter) || this.contains(item.name, this.search_filter) || this.contains(item.notes, this.search_filter)))
      }
    },
    get_filter_counts(status) {
      let items_tmp = this.items_full
      if (status) {
        items_tmp = items_tmp.filter(item => item.vehicle_status == status && !item.future_booking)
      }
      if (this.search_filter != '') {
        items_tmp = items_tmp.filter(item => (this.contains(item.start_bases, this.search_filter) || this.contains(item.name, this.search_filter)))
      }
      return items_tmp.length
    },
    contains(val1, val2) {
      if (val1 != null && val2 != null) {
        return String(val1).toLowerCase().indexOf(String(val2).toLowerCase()) != -1;
      }
      return false;
    },
    get_row_color(item) {
      if (item && !this.driver_mode) {
        if (item.vehicle_status)
          return item.vehicle_status.toLowerCase()
        else
          return "unknown";
      }
    },
},
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    ready_cnt() {
      return this.get_filter_counts('READY')
    },
    clean_cnt() {
      return this.get_filter_counts('CLEANED')
    },
    washed_cnt() {
      return this.get_filter_counts('WASHED')
    },
    dirty_cnt() {
      return this.get_filter_counts('DIRTY')
    },
    out_cnt() {
      return this.get_filter_counts('OUT')
    },
    oos_cnt() {
      return this.get_filter_counts('OOS')
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    reload_mode(val) {
      this.stopTimer()
      if (val > 0)
        this.startTimer()
    },
    '$pageVisibility.hidden'(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.resetTimerAndReload()
      }
    }
  }
}
</script>

<style scoped>
.total { border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}

.cleaned { background-color: hsla(190,70%,50%,0.4); border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}
.washed { background-color: hsla(160,30%,40%,0.4); border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}
.ready { background-color: hsla(120,100%,75%,0.3); border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}
.oos { background-color: hsla(357,78%,65%,0.4); border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}
.dirty { background-color: hsla(25,28%,23%,0.4); border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}
.out { background-color: hsla(290,60%,70%,0.3); border: 1px solid grey; border-radius: 5px; padding: 6px 0px 0px 0px; margin:2px}

.unknown td { background-color: white !important;}
.cleaned td { background-color: hsla(190,70%,50%,0.4); border: 1px solid black !important;}
.washed td { background-color: hsla(160,30%,40%,0.4); border: 1px solid black !important; }
.ready td { background-color: hsla(120,100%,75%,0.3); border: 1px solid black !important; }
.oos td { background-color: hsla(357,78%,65%,0.4); border: 1px solid black !important; }
.dirty td { background-color: hsla(25,28%,23%,0.4); border: 1px solid black !important; }
.out td { background-color: hsla(290,60%,70%,0.3); border: 1px solid black !important; }

div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
  /* overflow-wrap: break-word; */
}

.stats { border-radius: 5px; margin:2px}
</style>

